export default __webpack_public_path__ + "static/media/107.764c2d7f.jpg";